import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { SignalElement, inject } from "ui-common/di";
import type { IAuthState } from "ui-common/services/auth/types";
import { feedbackLabelStyles } from "./feedback-label.css";

import "./create-feedback-modal";
import "@phosphor-icons/webcomponents/PhChats";

@customElement("feedback-label")
export class FeedbackLabel extends SignalElement {
  static override styles = [feedbackLabelStyles];

  @inject<IAuthState>("authState")
  private authState!: IAuthState;

  @property({ type: String }) labelButtonText = "Feedback";
  @property({ type: String }) headerText = "We'd love your feedback 💬";
  @property({ type: String }) sentimentMessage = "How did you experience?";
  @property({ type: String }) sentimentPrompt = "What could we improve to make this easier for you?";
  @property({ type: String }) labelPrompt = "Share your thoughts with us";
  @property({ type: String }) labelPlaceholder = "Type your feedback here...";
  @property({ type: String }) labelError = "Oops, feedback can't be empty.";
  @property({ type: String }) successMessage = "Thanks for sharing! You're helping us make WOW even better.";
  @property({ type: String }) footerButtonText = "Send feedback";
  @property({ type: String }) footerButtonLoadingText = "Sending feedback...";
  @property({ type: Boolean }) isPreviewMode = false;

  @state()
  isFeedbackModalOpen = false;

  private handleFeedbackClick = () => {
    // Don't open modal in preview mode
    if (this.isPreviewMode) {
      return;
    }
    this.isFeedbackModalOpen = true;
  };

  override render() {
    if (!this.isPreviewMode && !this.authState.isAuthenticated.get()) {
      return nothing;
    }

    const buttonClasses = `feedback ${this.isPreviewMode ? "preview-mode" : ""}`;

    return html`
      <wow-button class=${buttonClasses} variant="neutral" size="small" @click=${this.handleFeedbackClick}>
        <ph-chats size="16"></ph-chats>
        ${this.labelButtonText}
      </wow-button>
      ${this.isFeedbackModalOpen
        ? html`<create-feedback-modal
            variant="label"
            @modal-close=${() => (this.isFeedbackModalOpen = false)}
            sentimentMessage=${this.sentimentMessage}
            sentimentPrompt=${this.sentimentPrompt}
            labelPrompt=${this.labelPrompt}
            labelPlaceholder=${this.labelPlaceholder}
            labelError=${this.labelError}
            successMessage=${this.successMessage}
            headerText=${this.headerText}
            footerButtonText=${this.footerButtonText}
            footerButtonLoadingText=${this.footerButtonLoadingText}
          ></create-feedback-modal>`
        : nothing}
    `;
  }
}
